import './index.css';

// Text block half of page
function Synopsis() {
    return (
        <section className="Synopsis">
            <h1>"You can not read the future without reading the past."</h1>
        </section>
    )
}

export default Synopsis;
